

export default getModule;
import { parse } from 'acorn';
import MagicString from 'magic-string';
import findImportsAndExports from 'utils/ast/findImportsAndExports';
import annotateAst from 'utils/ast/annotate';
import disallowConflictingImports from '../utils/disallowConflictingImports';
function getModule(mod) {
	mod.body = new MagicString(mod.code);

	var toRemove = [];
	var comments = [];

	try {
		mod.ast = mod.ast || parse(mod.code, {
			ecmaVersion: 6,
			sourceType: 'module',
			onComment: function (block, text, start, end) {
				// sourceMappingURL comments should be removed
				if (!block && /^# sourceMappingURL=/.test(text)) {
					toRemove.push({ start: start, end: end });
				} else {
					comments.push({ start: start, end: end });
				}
			}
		});
	} catch (err) {
		// If there's a parse error, attach file info
		// before throwing the error
		if (err.loc) {
			err.file = mod.path;
		}

		throw err;
	}

	// remove sourceMappingURL comments
	toRemove.forEach(function (_ref) {
		var start = _ref.start;
		var end = _ref.end;
		return mod.body.remove(start, end);
	});

	var _findImportsAndExports = findImportsAndExports(mod.ast, mod.code, comments);

	var imports = _findImportsAndExports.imports;
	var exports = _findImportsAndExports.exports;
	var defaultExport = _findImportsAndExports.defaultExport;

	disallowConflictingImports(imports);

	mod.imports = imports;
	mod.exports = exports;
	mod.defaultExport = defaultExport;

	var defaultExportIdentifier = defaultExport && defaultExport.type === 'expression' && defaultExport.node.declaration && defaultExport.node.declaration.type === 'Identifier' && defaultExport.node.declaration;

	// if the default export is an expression like `export default foo`, we
	// can *probably* just use `foo` to refer to said export throughout the
	// bundle. Tracking assignments to `foo` allows us to be sure that that's
	// the case (i.e. that the module doesn't assign a different value to foo
	// after it's been exported)
	annotateAst(mod.ast, {
		trackAssignments: defaultExportIdentifier
	});

	if (defaultExportIdentifier && defaultExportIdentifier._assignments) {
		var i = defaultExportIdentifier._assignments.length;
		while (i--) {
			var assignment = defaultExportIdentifier._assignments[i];

			// if either a) the assignment happens inside a function body, or
			// b) it happens after the `export default ...`, then it's unsafe to
			// use the identifier, and we need to essentially do `var _foo = foo`
			if (assignment.scope.parent || assignment.node.start > defaultExport.start) {
				defaultExport.unsafe = true; // TODO better property name than 'unsafe'
				break;
			}
		}
	}

	// identifiers to replace within this module
	// (gets filled in later, once bundle is combined)
	mod.identifierReplacements = {};

	// collect exports by name, for quick lookup when verifying
	// that this module exports a given identifier
	mod.doesExport = {};

	exports.forEach(function (x) {
		if (x.isDefault) {
			mod.doesExport['default'] = true;
		} else if (x.name) {
			mod.doesExport[x.name] = true;
		} else if (x.specifiers) {
			x.specifiers.forEach(function (s) {
				mod.doesExport[s.as] = true;
			});
		} else {
			throw new Error('Unexpected export type');
		}
	});

	return mod;
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/bundler/getModule.js.01-babel.map